import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation, useNavigate } from 'react-router-dom';
import './App.css';
import { siteConfig } from './config';
import Speakers from './Speakers';
import Sponsors from './Sponsors';



// function ScrollToTop() {
//   const { pathname, hash } = useLocation();
//   const navigate = useNavigate();
//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [pathname]);

//   return null;
// }

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (hash) {
      // If we're not on home page but have a hash, navigate to home first
      if (pathname !== '/') {
        navigate('/' + hash);
      } else {
        // We're on home page, scroll to section
        setTimeout(() => {
          const element = document.querySelector(hash);
          if (element) {
            const header = document.querySelector('.header');
            const headerHeight = header ? header.offsetHeight : 0;
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerHeight - 20;
            
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }
        }, 100);
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash, navigate]);

  return null;
}

function FeaturedSessionCards() {
  const [activeIndex, setActiveIndex] = React.useState(0);
  
  const sessions = [
    { id: 1, image: '/images/SESSIONS-01.jpeg', title: 'Session 1 - Vascular Medicine' },
    { id: 2, image: '/images/SESSIONS-02.jpeg', title: 'Session 2 - Core Surgical Topics' },
    { id: 3, image: '/images/SESSIONS-03.jpeg', title: 'Session 3 - Core Surgical Topics' }
  ];

  return (
    <div className="featured-cards-container">
      {/* Main Featured Card */}
      <div className="featured-card-main">
        <div className="featured-card-wrapper">
          <img 
            src={sessions[activeIndex].image} 
            alt={sessions[activeIndex].title}
            className="featured-card-image"
          />
        </div>
      </div>

      {/* Thumbnail Preview Cards */}
      <div className="thumbnail-cards-row">
        {sessions.map((session, index) => (
          <div 
            key={session.id}
            className={`thumbnail-card ${index === activeIndex ? 'active' : ''}`}
            onClick={() => setActiveIndex(index)}
          >
            <img src={session.image} alt={session.title} />
            {index === activeIndex && <div className="active-indicator">Currently Viewing</div>}
          </div>
        ))}
      </div>
    </div>
  );
}

// // ADD THIS ENTIRE CAROUSEL COMPONENT HERE:
// function ImageCarousel() {
//   const [currentSlide, setCurrentSlide] = React.useState(0);
  
//   // Slideshow images (4 images, excluding the main banner)
//   const images = [
//      '/images/Speakers.jpeg', 
//     '/images/SESSIONS-01.jpeg',     // Session 1
//    '/images/SESSIONS-02.jpeg',     // Session 2
//     '/images/SESSIONS-03.jpeg',     // Session 3
//   ];

//   // Auto-play slideshow - changes every 5 seconds
//   React.useEffect(() => {
//     const timer = setInterval(() => {
//       setCurrentSlide((prev) => (prev + 1) % images.length);
//     }, 5000); // 5000ms = 5 seconds

//     return () => clearInterval(timer);
//   }, [images.length]);

//   const nextSlide = () => {
//     setCurrentSlide((prev) => (prev + 1) % images.length);
//   };

//   const prevSlide = () => {
//     setCurrentSlide((prev) => (prev - 1 + images.length) % images.length);
//   };

//   const goToSlide = (index) => {
//     setCurrentSlide(index);
//   };

//   return (
//     <div className="hero-carousel">
//       <div 
//         className="carousel-container"
//         style={{ transform: `translateX(-${currentSlide * 100}%)` }}
//       >
//         {images.map((image, index) => (
//           <div key={index} className="carousel-slide">
//             <img 
//               src={image} 
//               alt={`Vascular Voyages Conference ${index + 1}`}
//               className="hero-banner-image"
//             />
//           </div>
//         ))}
//       </div>

//       {/* Left/Right Navigation Arrows */}
//       <button 
//         className="carousel-arrow left" 
//         onClick={prevSlide}
//         aria-label="Previous slide"
//       >
//         ‹
//       </button>
//       <button 
//         className="carousel-arrow right" 
//         onClick={nextSlide}
//         aria-label="Next slide"
//       >
//         ›
//       </button>

//       {/* Dot Indicators */}
//       <div className="carousel-dots">
//         {images.map((_, index) => (
//           <button
//             key={index}
//             className={`carousel-dot ${index === currentSlide ? 'active' : ''}`}
//             onClick={() => goToSlide(index)}
//             aria-label={`Go to slide ${index + 1}`}
//           />
//         ))}
//       </div>
//     </div>
//   );
// }
function HomePage() {
  const location = useLocation();

  useEffect(() => {
    // Smooth scroll functionality for same-page navigation
    const smoothScroll = (e) => {
      if (e.target.classList.contains('nav-link')) {
        e.preventDefault();
        
        const targetId = e.target.getAttribute('href');
        
        if (targetId && targetId.startsWith('#')) {
          const targetSection = document.querySelector(targetId);
          
          if (targetSection) {
            const header = document.querySelector('.header');
            const headerHeight = header ? header.offsetHeight : 0;
            const targetPosition = targetSection.offsetTop - headerHeight - 20;
            
            window.scrollTo({
              top: targetPosition,
              behavior: 'smooth'
            });
          }
        }
      }
    };

    document.addEventListener('click', smoothScroll);

    // Handle navigation from other pages with hash
    if (location.hash) {
      setTimeout(() => {
        const targetId = location.hash;
        const targetSection = document.querySelector(targetId);
        
        if (targetSection) {
          const header = document.querySelector('.header');
          const headerHeight = header ? header.offsetHeight : 0;
          const targetPosition = targetSection.offsetTop - headerHeight - 20;
          
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    }

    return () => {
      document.removeEventListener('click', smoothScroll);
    };
  }, [location]);

  // Add this useEffect after your existing smooth scroll useEffect
  useEffect(() => {
    // Automatically highlight speaker names
    const sessionTopics = document.querySelectorAll('.session-topics li');
    
    sessionTopics.forEach(li => {
      const text = li.textContent;
      
      if (text.includes(' by Dr.') || text.includes(' by Col.')) {
        const html = li.innerHTML;
        const styledHtml = html.replace(
          /( by (?:Dr\.|Col\.) [^<]+?)(<|$)/gi,
          '<span class="session-speaker">$1</span>$2'
        );
        li.innerHTML = styledHtml;
      }
    });
  }, []);

  return (
    <div className="App">
      {/* Header */}
      
      {/* Hero Section */}
      <section id="home" className="hero-section">
        <img 
          src="/images/Final_Banner.png" 
          alt="Vascular Voyages Conference Banner" 
          className="hero-banner-image"
        />
      </section>



      {/* Session Images Section - Professional Cards */}
      {/* <section className="session-cards-section">
        <div className="session-cards-container">
          <div className="session-card">
            <img src="/images/SESSIONS-01.jpeg" alt="Session 1 - Vascular Medicine" />
          </div>
          <div className="session-card">
            <img src="/images/SESSIONS-02.jpeg" alt="Session 2 - Core Surgical Topics" />
          </div>
          <div className="session-card">
            <img src="/images/SESSIONS-03.jpeg" alt="Session 3 - Core Surgical Topics" />
          </div>
        </div>
      </section>
 */}

{/* Session Images Section - Featured Card with Thumbnails */}
      <section className="session-cards-section">
        <FeaturedSessionCards />
      </section>


 {/* <section id="home" className="hero-section">
        <ImageCarousel />
      </section> */}

      <section className="speakers-showcase-section">
        <h2 className="section-title">Global Visionaries</h2>
        <div className="speakers-card-container">
          <img src="/images/Speakers_new.png" alt="International Speakers" className="speakers-showcase-image" />
        </div>
      </section>


      {/* Key Highlights Section - Now First */}
      <section className="content-section" style={{backgroundColor: '#ffffff'}}>
        <h2 className="section-title">Conference Highlights</h2>
        
        {/* Professional Description Card */}
        <div className="conference-description-card">
          <div className="description-content">
            <p className="description-intro">
              Femoro-popliteal arterial disease remains one of the most technically demanding and strategically nuanced domains in contemporary vascular surgery. As technology advances and evidence evolves, optimal management requires not only knowledge — but judgment, experience, and procedural excellence.
            </p>
            <p className="description-text">
              This high-level academic summit convenes distinguished faculty and dedicated vascular specialists for a focused three-day program devoted exclusively to the femoro-popliteal segment.
            </p>
            
            <div className="summit-highlights">
              <h3 className="summit-title">Summit Highlights</h3>
              <ul className="summit-list">
                <li>Comprehensive scientific sessions integrating global evidence with expert clinical insight</li>
                <li>Advanced discussions on medical optimization, open reconstruction, and endovascular innovation</li>
                <li>Technical strategy for complex lesions and limb salvage</li>
                <li>Faculty-led interactive deliberations and expert panel insights</li>
                <li>Live demonstration of 2 open and 2 endovascular procedures with real-time decision-making analysis</li>
              </ul>
            </div>
            
            <p className="description-footer">
              Designed for practicing vascular surgeons and surgeons in advanced training, this summit fosters a collegial environment of shared expertise, critical thinking, and surgical refinement.
            </p>
            
            <p className="description-tagline">
              An academic platform where experience meets innovation — and strategy defines outcomes.
            </p>
          </div>
        </div>
        
        <div className="section-content">
          {/* <p>
            Join us for an enriching experience featuring cutting-edge presentations, networking opportunities, 
            and collaborative discussions on femoral-popliteal interventions with leading healthcare professionals.
          </p> */}
          <div className="key-points">
            <h3>What to Expect</h3>
            <div className="highlights-grid">
              <div className="highlight-item">
                <div className="highlight-content">
                  <span className="highlight-icon">📚</span>
                  <div className="highlight-text">
                    <p>Comprehensive Coverage of Femoral-Popliteal Interventions</p>
                  </div>
                </div>
              </div>
              <div className="highlight-item">
                <div className="highlight-content">
                  <span className="highlight-icon">🔬</span>
                  <div className="highlight-text">
                    <p>Latest Advances in Vascular & Endovascular Surgery</p>
                  </div>
                </div>
              </div>
              <div className="highlight-item">
                <div className="highlight-content">
                  <span className="highlight-icon">👨‍⚕️</span>
                  <div className="highlight-text">
                    <p>Distinguished Expert Faculty from Leading Institutions</p>
                  </div>
                </div>
              </div>
              <div className="highlight-item">
                <div className="highlight-content">
                  <span className="highlight-icon">💬</span>
                  <div className="highlight-text">
                    <p>Interactive Sessions with Q&A and Case Discussions</p>
                  </div>
                </div>
              </div>
              <div className="highlight-item">
                <div className="highlight-content">
                  <span className="highlight-icon">🔄</span>
                  <div className="highlight-text">
                    <p>Latest Updates on Devices, Techniques & Technologies</p>
                  </div>
                </div>
              </div>
              <div className="highlight-item">
                <div className="highlight-content">
                  <span className="highlight-icon">🏥</span>
                  <div className="highlight-text">
                    <p>Live Demonstrations & Hands-On Workshop Experience</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Chairman's Message Section */}
      <section className="chairman-message-section">
        <div className="chairman-container">
          <div className="chairman-photo-wrapper">
            <div className="chairman-photo-circle">
              <img 
                src="/images/chairman-photo.png" 
                alt="Chairman" 
                className="chairman-photo"
              />
            </div>
          </div>
          
          <div className="chairman-content">
            <h2 className="chairman-title">A Message from the Chairman</h2>
            
            <p className="chairman-greeting">Dear Distinguished Guests and Colleagues,</p>
            
            <div className="chairman-message-text">
              <p>
                It gives me great pleasure to welcome you to this focused conference dedicated to the comprehensive management of femoro-popliteal arterial disease. As vascular specialists, we recognize that this segment represents one of the most complex and evolving areas in contemporary practice — demanding sound clinical judgment, technical mastery, and adaptability to rapidly advancing technologies. Over the past decade, we have witnessed significant progress in medical optimization, open surgical reconstruction, and endovascular innovation. Yet, successful limb salvage continues to depend not merely on devices or techniques, but on thoughtful strategy, meticulous execution, and disciplined decision-making. This meeting has been structured to provide a balanced and evidence-based discourse, integrating academic rigor with practical insight from experienced faculty.
              </p>
              <p>
                Importantly, this conference aims to foster meaningful academic exchange between practicing consultants and surgeons in training. By combining focused scientific sessions with live procedural demonstrations, we hope to create an environment that strengthens clinical reasoning, refines operative skill, and inspires the next generation of vascular surgeons. I warmly invite you to join us for three days of intensive learning, collaboration, and advancement in femoro-popliteal revascularization.
              </p>
            </div>
            
            <p className="chairman-closing">With best regards,</p>
            <p className="chairman-thanks">
              Thank you for being part of this distinguished forum that makes this gathering 
              a catalyst for change.
            </p>
            
            <div className="chairman-signature-block">
              {/* <img 
                src="/images/chairman-signature.png" 
                alt="Signature" 
                className="chairman-signature"
              /> */}
              <p className="chairman-name">Dr. Narendranadh Meda </p>
              <p className="chairman-designation">HOD & Senior Consultant,</p>
              <p className="chairman-designation">Department of Vascular & Endovascular Surgery</p>
              <p className="chairman-designation">KIMS Hospital, Minister Road, Secunderabad</p>
            </div>
          </div>
        </div>
      </section>

      {/* Committee Section with Image */}
      <section id="committee" className="content-section faculty-section" style={{backgroundColor: '#f8f9fa'}}>
        <h2 className="section-title">Our Distinguished Faculty & Committee</h2>
        <div className="section-content">
          <p>
            Learn from renowned experts and leading practitioners in vascular and endovascular surgery 
            who bring decades of clinical experience and cutting-edge knowledge to share.
          </p>
        </div>
        <div className="faculty-image-section">
          <img 
            src="/images/Committee_Latest.png" 
            alt="Committee Members" 
            className="committee-image"
          />
        </div>
        
        {/* Additional Faculty Members List */}
        {/* <div className="additional-faculty">
          <h3 className="additional-faculty-title">Organising Committee</h3>
          <div className="organizing-committee-card">
            <div className="committee-members-list">
              <p className="committee-member-name">Dr K Priya Bharathi</p>
              <p className="committee-member-name">Dr Vishal Bulla</p>
              <p className="committee-member-name">Dr Jyotsna Choudary Gogineni</p>
              <p className="committee-member-name">Dr Sreeraj Asok</p>
              <p className="committee-member-name">Dr Suma Vally</p>
              <p className="committee-member-name">Dr Karan Gupta</p>
              <p className="committee-member-name">Dr W G Sthithi</p>
              <p className="committee-member-name">Dr Farhana</p>
              <p className="committee-member-name">Dr Bhramaramba Balla</p>
            </div>
          </div>
        </div> */}
      </section>

      {/* Program Section */}

      {/* Program Section */}
      <section id="program" className="content-section program-section">
        <h2 className="section-title">Program Schedule</h2>
        
        {/* Day 1 */}
        <div className="day-schedule">
          <div className="day-header">
            <h3>Day 1 - Friday, 13th March 2026</h3>
          </div>
          
          <div className="session-block">
            <div className="session-header">
              <h4>Registration</h4>
              <span className="session-time">10:30 AM</span>
            </div>
          </div>

          <div className="session-block">
            <div className="session-header">
              <h4>Pre-Conference Workshop - HawkOne Workshop</h4>
              <span className="session-time">11:00 AM - 1:00 PM</span>
            </div>
            <div className="session-title"><span style={{color: '#c41e3a', fontWeight: '700', background: 'linear-gradient(135deg, #c41e3a 0%, #e63946 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text'}}>Dr. Chandrashekar A.R</span></div>
            <ul className="session-topics">
              <li>Welcome & Introduction (11:00 AM - 11:10 AM)</li>
              <li>Challenges in treating complex SFA lesions (11:10 AM – 11:30 AM)</li>
              <li>Atherectomy in PAD (11:30 AM – 12:00 Noon)</li>
              <li>DA+DCB and HawkOne Clinical evidence (12:00 Noon – 12:20 PM)</li>
              <li>Case Planning and Hardware Required (12:20 PM – 12:50 PM)</li>
              <li>Closing Remarks (12:50 PM – 1:00 PM)</li>
            </ul>
          </div>

          <div className="break-time">Lunch: 1:00 PM - 1:30 PM</div>

          <div className="session-block">
            <div className="session-header">
              <h4>Welcome & Introduction to the Conference</h4>
            </div>
          <div className="session-title">By <span className="session-speaker">Dr. Narendranadh Meda</span></div> 
         </div>

          <div className="session-block">
            <div className="session-header">
              <h4>Session 1: Vascular Medicine</h4>
              <span className="session-time">1:30 PM - 2:30 PM</span>
            </div>
            <div className="session-meta">
              <p><strong>Moderator:</strong> <span>Dr. N. Sritharan</span></p>
              <p><strong>Chairperson:</strong> <span>Dr. Bheem Sangars, Dr. Pratap Kumar S</span></p>
              <p><strong>Panelist:</strong> <span>Dr. Gnanendra, Dr. Sahaja Rao</span></p>
            </div>
            <div className="session-title">(Each talk 8 + 2 minutes)</div>
            <ul className="session-topics">
              <li>Pharmacotherapy - Unlocking Circulation Medically by Dr. Vishwanath Atreya</li>
              <li>Antiplatelets and Antithrombotics - COMPASS to VOYAGER by Dr. P.C. Gupta</li>
              <li>Lipid-Lowering agents - Beyond Statins by Dr. Jitin Jagan</li>
              <li>Blood Pressure and Glycemic Control - Striking the Right Balance by Dr. Rahul L N</li>
              <li>Smoking Cessation in PAD - Underused weapon by Dr. Abha Chandra</li>
              <li>Different Imaging modalities - Microscopic view by Dr. Adarsh Kabra</li>
            </ul>
          </div>

          <div className="session-block">
            <div className="session-header">
              <h4>Session 2: Core Surgical Topics</h4>
              <span className="session-time">2:30 PM - 3:20 PM</span>
            </div>
            <div className="session-meta">
              <p><strong>Moderator:</strong> <span>Dr. Robbie George</span></p>
              <p><strong>Chairperson:</strong> <span>Dr. Sandeep Mahapatra, Dr. Advait Kothurkar</span></p>
              <p><strong>Panelist:</strong> <span>Dr. Venkata Prasanna, Dr. Sanjeev Rao</span></p>
            </div>
            <div className="session-title">(Each talk 8 + 2 minutes)</div>
            <ul className="session-topics">
              <li>When to intervene? - Time is tissue by Dr. Tapish Sahu</li>
              <li>Anatomy & Exposure of CFA-SFA-PFA - Mastering the Groin by Dr. Shivanesan P</li>
              <li>Anatomy & Exposure of Popliteal artery - Targeting the knee pit by Dr. R.C. Sree Kumar</li>
              <li>Target Selection in Distal Bypass - The Right spot by Dr. Sairam S</li>
              <li>Open Bypass Surgery Techniques - Reclaim your stride by Dr. S. Robinson</li>
            </ul>
          </div>

          <div className="session-block">
            <div className="session-header">
              <h4>Session 3: Core Surgical Topics (Continued)</h4>
              <span className="session-time">3:20 PM - 4:00 PM</span>
            </div>
            <div className="session-meta">
              <p><strong>Moderator:</strong> <span>Dr. Sumanth Raj</span></p>
              <p><strong>Chairperson:</strong> <span>Dr. Shivanesan P, Col. Dr. Manvendu Jha</span></p>
              <p><strong>Panelist:</strong> <span>Dr. Hemanth, Dr. Surendra N</span></p>
            </div>
            <div className="session-title">(Each talk 8 + 2 minutes)</div>
            <ul className="session-topics">
              <li>Autologous Vein vs Prosthetic Grafts - The optimal conduit question by Dr. Velladuraichi B</li>
              <li>Conduits and Anastomotic Techniques - Bridging the gap with precision by Dr. Rajesh S</li>
              <li>Persistent Sciatic Artery - Rare Anatomy Real Risk by Dr. N. Sritharan</li>
              <li>Popliteal Artery Entrapment Syndrome - Untrapping the Vessel by Dr. Arvind Kohli</li>
            </ul>
          </div>

          <div className="break-time">Tea Break: 4:00 PM - 4:10 PM</div>

          <div className="session-block">
            <div className="session-header">
              <h4>Session 4: Technique-Focused Surface Dive</h4>
              <span className="session-time">4:10 PM - 4:50 PM</span>
            </div>
            <div className="session-meta">
              <p><strong>Moderator:</strong> <span>Dr. Nihar Ranjan Pradhan</span></p>
              <p><strong>Chairperson:</strong> <span>Dr. Sandeep Raj Pandey, Dr. Sharmila Suresh</span></p>
              <p><strong>Panelist:</strong> <span>Dr. Athirath Reddy, Dr. Sarath Chandra P</span></p>
            </div>
            <div className="session-title">(Each talk 8 + 2 minutes)</div>
            <ul className="session-topics">
              <li>Technical Pearls in Above Knee Bypass - Flow without Friction (Video) by Dr. Ravi Kumar</li>
              <li>Technical Pearls in Below Knee Bypass - Difficult paths, Powerful outcomes (Video) by Dr. Ilaya Kumar</li>
              <li>Endarterectomy: A Lost Art or a Viable Option? by Dr. Shivananda S</li>
              <li>Intraoperative Imaging and Flow Assessment - Visualising Success by Dr. Rajarajan V</li>
            </ul>
          </div>

          <div className="session-block">
            <div className="session-header">
              <h4>Session 5: Technique-Focused Deep Dive</h4>
              <span className="session-time">4:50 PM - 5:30 PM</span>
            </div>
            <div className="session-meta">
              <p><strong>Moderator:</strong> <span>Dr. Amish Mhatre</span></p>
              <p><strong>Chairperson:</strong> <span>Dr. Kapil Baliga, Dr. Apurva Srivastav</span></p>
              <p><strong>Panelist:</strong> <span>Dr. Vijay Kumar Vishnumolakala, Dr. Harikamal</span></p>
            </div>
            <div className="session-title">(Each talk 8 + 2 minutes)</div>
            <ul className="session-topics">
              <li>Reoperating Femoropopliteal Region - Hostile battle field by Dr. Elancheralathan</li>
              <li>When Open Complements Endovascular Therapy - Uniting techniques by Dr. R. Shekar</li>
              <li>Techniques to avoid graft infection - Graft Defense by Dr. C. Chandrashekar</li>
              <li>Composite sequential profundal vein - Hitch-Hike technique by Dr. Radhakrishnanan Raju</li>
            </ul>
          </div>

          <div className="session-block">
            <div className="session-header">
              <h4>Session 6: Decision-Making And Controversies</h4>
              <span className="session-time">5:30 PM - 6:10 PM</span>
            </div>
            <div className="session-meta">
              <p><strong>Moderator:</strong> <span>Dr. Sanjay Desai</span></p>
              <p><strong>Chairperson:</strong> <span>Dr. Prabhakar, Dr. Vishal Seth</span></p>
              <p><strong>Panelist:</strong> <span>Dr. Puneeth, Dr. Venu Gopal Kulkarni</span></p>
            </div>
            <div className="session-title">(Each talk 8 + 2 minutes)</div>
            <ul className="session-topics">
              <li>Open vs Endovascular First - Open back or Fast track by Dr. Arunagiri V</li>
              <li>When Endovascular Fails! - Turn to the knife when the wire fails by Dr. Sidharth V</li>
              <li>The Role of Open Surgery in the Era of DCB's and Stents - Old wisdom by Dr. Devender Singh</li>
              <li>Patient Selection for Bypass: Beyond Guidelines - The Tailored Bypass by Dr. Bhaktavatsalam</li>
            </ul>
          </div>

          <div className="session-block">
            <div className="session-header">
              <h4>Session 7: Outcomes And Innovations</h4>
              <span className="session-time">6:10 PM - 6:50 PM</span>
            </div>
            <div className="session-meta">
              <p><strong>Moderator:</strong> <span>Dr. Vasanth Kumar Reddy</span></p>
              <p><strong>Chairperson:</strong> <span>Dr. Narendranadh Meda, Dr. Sunil Rajendran</span></p>
              <p><strong>Panelist:</strong> <span>Dr. Tejas K, Dr. Simit Vora</span></p>
            </div>
            <div className="session-title">(Each talk 8 + 2 minutes)</div>
            <ul className="session-topics">
              <li>Endovascular approaches for complex diseases - Navigating the maze by Dr. Marco Manzi (Virtual)</li>
              <li>Long-Term Patency of bypass: What the Data Says - Build to Last by Dr. Digvijay Sharma</li>
              <li>Next Generation Grafts - Seamless connections by Dr. Martin Maresch (Virtual)</li>
              <li>Training the Next Generation - Modern Vascular Specialists by Dr. V.S. Bedi</li>
            </ul>
          </div>

          <div className="gala-dinner-highlight">
            <div className="gala-dinner-icon">🍽️</div>
            <div className="gala-dinner-content">
              <h4 className="gala-dinner-title">Gala Dinner</h4>
              <p className="gala-dinner-time">7:00 PM onwards</p>
              <p className="gala-dinner-subtitle">Join us for an evening of networking and celebration</p>
            </div>
          </div>
        </div>

        {/* Day 2 */}
        <div className="day-schedule">
          <div className="day-header">
            <h3>Day 2 - Saturday, 14th March 2026</h3>
          </div>

          <div className="session-block">
            <div className="session-header">
              <h4>Session 8: Clinical Strategies</h4>
              <span className="session-time">8:30 AM - 9:40 AM</span>
            </div>
            <div className="session-meta">
              <p><strong>Moderator:</strong> <span>Dr. V. S Bedi</span></p>
              <p><strong>Chairperson:</strong> <span>Col. Dr. Manvendhu Jha, Dr. Devender Singh</span></p>
              <p><strong>Panelist:</strong> <span>Dr. Srikanth Raju, Dr. Krunal</span></p>
            </div>
            <div className="session-title">(Each talk 8 + 2 minutes)</div>
            <ul className="session-topics">
              <li>Global treatment algorithms - Precision care defined by Dr. Gnaneshwar A</li>
              <li>Pre and Post Endovascular Intervention Ultrasound - Visualising the impact by Jill Sommerset (Virtual)</li>
              <li>Evolution of Endovascular therapy - Opening pathways - saving limbs by Dr. Bhavin L Ram</li>
              <li>Role of lesion length and morphology - Lesion complexity decoded by Dr. Sundar Narasimhan</li>
              <li>Management of chronic total occlusions - Beyond the block by Dr. Adarsh Kabra</li>
              <li>When endo and open fails - The untameable lion by Dr. Chandra Shekar A. R</li>
              <li>Access and Access related complications - Safety First by Dr. P. Ilaya Kumar</li>
            </ul>
          </div>

          <div className="session-block">
            <div className="session-header">
              <h4>Session 9: Decision Making</h4>
              <span className="session-time">9:40 AM - 10:30 AM</span>
            </div>
            <div className="session-meta">
              <p><strong>Moderator:</strong> <span>Dr. Ajay Yadav</span></p>
              <p><strong>Chairperson:</strong> <span>Dr. A.R. Chandrashekar, Dr. Shivananda S</span></p>
              <p><strong>Panelist:</strong> <span>Dr. Venkatesh Bollineni, Dr. Ranjith Kumar</span></p>
            </div>
            <div className="session-title">(Each talk 8 + 2 minutes)</div>
            <ul className="session-topics">
              <li>Endovascular vs Surgical Bypass - Wires vs Knives by Dr. Pritee Sharma</li>
              <li>Endovascular Salvage for a Failed Bypass – Rewiring the Recurrences by Dr. Narendranadh Meda</li>
              <li>In-stent stenosis and occlusions - Taming the Neointima by Dr. R. Tripathi (Virtual)</li>
              <li>Stent Fracture Management - The Broken Bridge by Dr. V.S. Bedi</li>
              <li>Popliteal Artery Stenting - To or Not to? by Dr. Kapil Baliga</li>
            </ul>
          </div>

          <div className="break-time">Tea Break: 10:30 AM - 10:40 AM</div>

          <div className="session-block">
            <div className="session-header">
              <h4>Session 10: Endovascular Suite & Hardwares</h4>
              <span className="session-time">10:40 AM - 11:20 AM</span>
            </div>
            <div className="session-meta">
              <p><strong>Moderator:</strong> <span>Dr. Tarun Grover</span></p>
              <p><strong>Chairperson:</strong> <span>Dr. Sairam Subramaniam, Dr. Prakash Goura</span></p>
              <p><strong>Panelist:</strong> <span>Dr. Hemanth, Dr. Rahul Agarwal</span></p>
            </div>
            <div className="session-title">(Each talk 8 + 2 minutes)</div>
            <ul className="session-topics">
              <li>Catheterisation Laboratory - Our Second Home by Dr. Sharmila Suresh</li>
              <li>Hardware - Smart solutions for tough vessels by Dr. Pratap Kumar S</li>
              <li>Bare metal & Covered stents - Bare and Beyond by Dr. Ajay Yadav</li>
              <li>Drug Coated Balloons & Drug Eluting Stents - War on Hyperplasia by Dr. Sanjay Desai</li>
            </ul>
          </div>

          <div className="session-block">
            <div className="session-header">
              <h4>Session 11: Advanced Inventory</h4>
              <span className="session-time">11:20 AM - 12:30 PM</span>
            </div>
            <div className="session-meta">
              <p><strong>Moderator:</strong> <span>Dr. C. Chandrashekar</span></p>
              <p><strong>Chairperson:</strong> <span>Dr. Aravind Kohli, Dr. Aruna Giri V</span></p>
              <p><strong>Panelist:</strong> <span>Dr. Haritha, Dr. Nikhila Pinjala</span></p>
            </div>
            <div className="session-title">(Each talk 8 + 2 minutes)</div>
            <ul className="session-topics">
              <li>Vasculomimetic stents - Stent that moulds by Dr. Luv Luthra</li>
              <li>Atherectomy - Shave- shape - save by Dr. Deepak Selvaraj</li>
              <li>IVL - Breaking the calcium ceiling by Dr. Robbie George</li>
              <li>Biodegradable scaffolds - Scaffold today, gone tomorrow by Dr. Dhanesh Kamerkar (Virtual)</li>
              <li>Embolic Protection Devices - Catch me if u can by Dr. Ranjith Kumar A</li>
              <li>Re-entry devices - Targeting the true lumen by Dr. Raghu L. Motaganahalli (Virtual)</li>
              <li>Closure Devices - Patching the hole by Dr. Vimal Iype</li>
            </ul>
          </div>

          <div className="session-block">
            <div className="session-header">
              <h4>Session 12: Techniques</h4>
              <span className="session-time">12:30 PM - 1:30 PM</span>
            </div>
            <div className="session-meta">
              <p><strong>Moderator:</strong> <span>Dr. Digvijay Singh</span></p>
              <p><strong>Chairperson:</strong> <span>Dr. Adarsh Kabra, Dr. Sandeep Raj Pandey</span></p>
              <p><strong>Panelist:</strong> <span>Dr. Sanjeev Rao, Dr. Surendra N</span></p>
            </div>
            <div className="session-title">(Each talk 8 + 2 minutes)</div>
            <ul className="session-topics">
              <li>Managing ostial lesions - where it all begins by Dr. Sunil Rajendran</li>
              <li>CFA Stenting - The New Frontier by Dr. Tarun Grover</li>
              <li>Crossing techniques for long femoropopliteal occlusions - Crossing the impossible by Dr. Sven Braunlich (Virtual)</li>
              <li>Retrograde access - Rethinking the Approach by Dr. Murali Krishna N</li>
              <li>Percutaneous Transmural Arterial Bypass - The Inside out Bypass by Dr. Venkatesh G. Ramaiah (Virtual)</li>
              {/* <li>Profundoplasty - Am I not important! by Dr. Vivekananda</li> */}
            </ul>
          </div>

          <div className="break-time">Lunch Break: 1:30 PM - 2:00 PM</div>

          <div className="session-block">
            <div className="session-header">
              <h4>Session 13: Outcomes and Evidences</h4>
              <span className="session-time">2:00 PM - 3:10 PM</span>
            </div>
            <div className="session-meta">
              <p><strong>Moderator:</strong> <span>Dr. R Shekar</span></p>
              <p><strong>Chairperson:</strong> <span>Dr. Rajesh S, Dr. Rohit Gupta</span></p>
              <p><strong>Panelist:</strong> <span>Dr. Nishan Reddy, Dr. Apoorva</span></p>
            </div>
            <div className="session-title">(Each talk 8 + 2 minutes)</div>
            <ul className="session-topics">
              <li>AI in predicting re-stenosis - Decoding failure by Dr. Himanshu Varma</li>
              <li>Patency rates after POBA & DCB - Balloon Durability by Dr. Apurva Srivastav</li>
              <li>Patency rates after Bare metal stents & Drug Eluting stents – Metal Durability by Dr. Nandin Haldipur (Virtual)</li>
              <li>Limb Salvage outcomes following intervention - Walking away from Amputation by Col. Dr. Kumud Rai</li>
              <li>Predictors of Restenosis - Visualising risk by Dr. Praveen Jindal</li>
              <li>Cost effectiveness of open Vs Endovascular procedures by Dr. Harsha G</li>
              <li>Endovascular therapy in resource limited settings - Maximise miles on budget by Dr. Shivananda S</li>
            </ul>
          </div>

          <div className="session-block">
            <div className="session-header">
              <h4>Session 14: Innovations and Future Directions</h4>
              <span className="session-time">3:10 PM - 4:20 PM</span>
            </div>
            <div className="session-meta">
              <p><strong>Moderator:</strong> <span>Dr. P. C Gupta</span></p>
              <p><strong>Chairperson:</strong> <span>Dr. Kiran Makineni, Dr. Sunil Rajendran</span></p>
              <p><strong>Panelist:</strong> <span>Dr. Ajay B Mosur, Dr. Surya Kiran Indukuri</span></p>
            </div>
            <div className="session-title">(Each talk 8 + 2 minutes)</div>
            <ul className="session-topics">
              <li>Covered Stents in Fempop Diseases - Shielding flow, sustaining freedom by Dr. Vishnu M</li>
              <li>Next generation drug technologies - The limus Leap by Dr. Paresh Pai</li>
              <li>Imaging innovations: IVUS and OCT - Depth meets detail by Dr. Amish Mhatre</li>
              <li>Global perspectives on skill development - Skills that sustain by Col. Dr. Manvendu Jha</li>
              <li>Lumiguide - Radiation free revolution by Dr. Harishankar Nair (Virtual)</li>
            </ul>
          </div>

          <div className="break-time">Tea Break: 4:20 PM - 4:30 PM</div>

          <div className="session-block special-session">
            <div className="session-header">
              <h4>Quiz</h4>
              <span className="session-time">4:30 PM - 5:30 PM</span>
            </div>
            <p className="session-description">For residents followed by prize distribution.</p>
          </div>

          <div className="session-block special-session">
            <div className="session-header">
              <h4>Vote of Thanks</h4>
              <span className="session-time">5:30 PM</span>
            </div>
          </div>
        </div>

        {/* Day 3 Workshop Note */}
        {/* <div className="day-schedule workshop-day" style={{marginTop: '40px'}}>
          <div className="day-header workshop-header">
            <h3>Day 3 - Sunday, 15th March 2026</h3>
          </div>
          <div className="session-block workshop-session">
            <div className="session-header">
              <h4>Live Workshop</h4>
              <span className="session-time">9:00 AM - 2:00 PM</span>
            </div>
            <div className="workshop-content">
              <ul className="workshop-list">
                <li><strong>2 Open Bypass Cases:</strong>
                  <ul>
                    <li>1 case with Vein conduit</li>
                    <li>1 case with Prosthetic conduit</li>
                  </ul>
                </li>
                <li><strong>2 Endovascular Interventions:</strong>
                  <ul>
                    <li>1 case of Atherectomy with Stenting</li>
                    <li>1 case with POBA</li>
                  </ul>
                </li>
              </ul>
              <p className="workshop-note"><strong>Limited Slots of 40 Residents</strong> (10 students in each suite)</p>
            </div>
          </div>

          <div className="break-time">Lunch: 2:00 PM - 3:00 PM</div>

          <div className="session-block workshop-session">
            <div className="session-header">
              <h4>Simulation Devices and Hands-On Training</h4>
              <span className="session-time">3:00 PM - 4:30 PM</span>
            </div>
          </div>
        </div> */}
        </section>

{/* <section id="program" className="content-section program-section">
        <div className="download-section">
          <h3>Download Complete Schedule</h3>
          <a 
            href="/downloads/Vascular_Voyages_Program_Schedule.pdf" 
            className="download-btn"
            download
          >
            Download Full Program PDF
          </a>
        </div>
      </section> */}

      {/* Workshop Section */}
      <section id="workshop" className="content-section">
        <h2 className="section-title">Workshop</h2>
        
        <div className="day-schedule workshop-day" style={{marginTop: '40px'}}>
          <div className="day-header workshop-header">
            <h3>Day 3 - Sunday, 15th March 2026</h3>
          </div>
          <div className="session-block workshop-session">
            <div className="session-header">
              <h4>Live Workshop at KIMS Hospitals</h4>
              <span className="session-time">9:00 AM - 3:00 PM</span>
            </div>
            <div className="workshop-content">
              <ul className="workshop-list">
                <li><strong>2 Open Bypass Cases:</strong>
                  <ul>
                    <li>1 case with Vein conduit</li>
                    <li>1 case with Prosthetic conduit</li>
                  </ul>
                </li>
                <li><strong>2 Endovascular Interventions:</strong>
                  <ul>
                    <li>1 case of Hawk One Atherectomy with Stenting</li>
                    <li>1 case with Angiopiasty and Jet Stream Atherectomy</li>
                  </ul>
                </li>
              </ul>
              <p className="workshop-note"><strong>Limited Slots of 40 Residents</strong> (10 students in each suite)</p>
            </div>
          </div>

          {/* <div className="break-time">Lunch: 2:00 PM - 3:00 PM</div> */}

          <div className="session-block workshop-session">
            <div className="session-header">
              <h4>Simulation Devices and Hands-On Training</h4>
              {/* <span className="session-time">3:00 PM - 4:30 PM</span> */}
            </div>
          </div>
        </div>
      </section>

      <section id="program" className="content-section program-section">
        <div className="download-section">
          <h3>Download Complete Schedule</h3>
          <a 
            href="/downloads/Vascular_Voyages_Schedule_Final_11th March.pdf" 
            className="download-btn"
            download
          >
            Download Full Program PDF
          </a>
        </div>
      </section>

      {/* Registration Section */}
      <section id="registration" className="content-section" style={{backgroundColor: '#f8f9fa'}}>
        <h2 className="section-title">Registration</h2>
        <div className="section-content">
          <div className="registration-info">
            <div className="registration-card">
              <h3>Consultants</h3>
              <p className="price">₹6,000/-</p>
            </div>
            <div className="registration-card">
              <h3>Residents</h3>
              <p className="price">₹5,000/-</p>
              <p className="sub-info">Conference with Workshop</p>
            </div>
            <div className="registration-card">
              <h3>Residents</h3>
              <p className="price">₹3,000/-</p>
              <p className="sub-info">Conference without Workshop</p>
            </div>
            <div className="registration-card">
              <h3>Sponsors</h3>
              <p className="price">₹6,000/-</p>
              {/* <p className="sub-info">For Sponsorship Details</p> */}
            </div>
          </div>
          <p className="complimentary-note">
            <strong>Complimentary stay on twin-sharing basis for all residents</strong>
          </p>


          {/* Registration Button */}
          <div className="registration-button-wrapper">
            <a
              href="https://formbuilder.ccavenue.com/live/ccavenue/vascular-voyages-2026"
              target="_blank"
              rel="noopener noreferrer"
              className="register-now-btn"
            >
              Register Now
            </a>
            <p className="registration-note">
              Clicking the button will take you to the official registration portal.
            </p>
          </div>

          {/* Hotel Booking Section */}
          <div className="hotel-booking-section">
            <h3 className="hotel-booking-title">🏨 Hotel Booking</h3>
            <div className="hotel-booking-content">
              <p className="hotel-booking-info">
                <strong>Book your accommodation now!</strong>
              </p>
              
              <a  href="https://www.marriott.com/event-reservations/reservation-link.mi?id=1771997883582&key=GRP&app=resvlink&_branch_match_id=1511288148136734895&_branch_referrer=H4sIAAAAAAAAA8soKSkottLXTywo0MtNLCrKzC8p0UvOz9UvSi3OyczLtgdK2ALZZSCOWmaKraG5uaGlpbmFhbGphZFadmqlrXtQgFpdUWpaKlB3Xnp8UlF%2BeXFqka1rSnoqAG9xLlheAAAA"
                target="_blank"
                rel="noopener noreferrer"
                className="hotel-booking-btn"
              >
                Book Hotel Room
              </a>
              <div className="hotel-booking-details">
                <p className="hotel-detail-item">⚠️ <strong>Limited rooms available</strong></p>
                <p className="hotel-detail-item">📅 Booking available till <strong>6th March 2026</strong></p>
                <p className="hotel-detail-item">✓ Rooms subject to availability</p>
              </div>
            </div>
          </div>

          

        </div>
      </section>

      {/* About Section - Now Last */}
      <section id="about" className="content-section">
        <h2 className="section-title">About Us</h2>
        <div className="section-content">
          <p>
            Welcome to Vascular Voyages, a premier medical conference bringing together leading healthcare 
            professionals, researchers, and industry experts. This comprehensive conference is organized by 
            the Department of Vascular & Endovascular Surgery at KIMS Hospitals, Hyderabad, one of India's 
            leading healthcare institutions renowned for excellence in vascular care.
          </p>
          <br />
          <p>
            Our mission is to advance the field of vascular and endovascular surgery by facilitating knowledge 
            exchange, promoting best practices, and fostering collaboration among medical professionals. Through 
            cutting-edge presentations, live demonstrations, and interactive workshops, we aim to bridge the gap 
            between theory and practice in femoral-popliteal interventions.
          </p>
        </div>
      </section>

 <section id="contact" className="content-section" style={{backgroundColor: '#f8f9fa'}}>
        <h2 className="section-title">Contact Us</h2>
        <div className="section-content">
          <div className="contact-info">
            <p><strong>Conference Secretariat:</strong></p>
            <p><strong>Email:</strong> vascularvoyages.kims@gmail.com</p>
            <p>Dept. of Vascular & Endovascular Surgery</p>
            <p>KIMS Hospitals, Minister Road, Secunderabad</p>
            <p><strong>Phone:</strong> 6261268804 / 8904157854</p>
          </div>
        </div>
      </section>

      {/* Footer */}
      
    </div>
  );
}

function App() {
  return (
    <Router>
            <div className="App">

      <header className="header">
        <div className="header-container">
          <div className="logo-container">
            <img 
              src={siteConfig.logo.path} 
              alt={siteConfig.logo.alt} 
              className="logo"
            />
          </div>
          <nav className="nav-container">
            <ul className="navigation">
              <li>
                <a href="#home" className="nav-link">HOME</a>
              </li>
              {/* <li>
                <Link to="/faculty" className="nav-link">FACULTY</Link>
              </li> */}
              <li>
                <a href="#committee" className="nav-link">COMMITTEE</a>
              </li>
              <li>
                <a href="#program" className="nav-link">PROGRAM SCHEDULE</a>
              </li>
              <li>
                <a href="#workshop" className="nav-link">WORKSHOP</a>
              </li>
              <li>
                <a href="#registration" className="nav-link">REGISTRATION</a>
              </li>
              <li>
                <Link to="/sponsors" className="nav-link">SPONSORS</Link>
              </li>
              <li>
                <a href="#about" className="nav-link">ABOUT US</a>
              </li>
            </ul>
          </nav>
        </div>
      </header>

      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/faculty" element={<Speakers />} />
        <Route path="/sponsors" element={<Sponsors />} />

     
      </Routes>
        
         <footer className="footer">
        <p>&copy; Vascular Voyages - KIMS Hospitals, Secunderabad. All rights reserved.</p>
        <p>For inquiries, contact us at 6261268804 / 8904157854</p>
      </footer>
        </div>


    </Router>
  );
}

export default App;